import { environment } from './environment';

export const CENTRAL_HUB_BASE_URL = `${environment.apiUrl}/central`;
export const PLATFORM_BASE_URL = `${environment.apiUrl}/platform`;
export const AGGREGATOR_BASE_URL = `${environment.apiUrl}/aggregator`;
export const AGGREGATOR_V2_BASE_URL = `${environment.apiUrlV2}/aggregator`;
export const BROADGUARD_BASE_URL = `${environment.apiUrl}/broadguard`;
export const CRM_BASE_URL = `${environment.apiUrl}/crm`;
export const AUTH_BASE_URL = `${environment.apiUrlV2}/central`;
